module.exports = __webpack_public_path__ + "static/movil-ebe237de12c9ad38a0f8d79992d11bd6.jpg";